module.exports = __webpack_public_path__ + "media/images/sales/weddingday/thumb-pricing-02-058e7ee16962f0d4caaf6add7a04ec57.svg";